import React from 'react';
import TextView from '../../TextView';
import { ASSETS } from '../../../utils/config';
import { NOTIFICATION_TYPES } from '../../../utils/notificationTypes';
import {
  NotificationContainer,
  LeftSection,
  ImageContainer,
  ProfileImage,
  RightSection,
  WheelImage,
  TextContainer,
  IconOverlay,
  ActionButtonsContainer,
  StyledButton,
  GreenDot,
} from './NotificationItem.styled';
import { useNavigate } from 'react-router-dom';

// Mapping type to icons using NOTIFICATION_TYPES
const iconMap = {
  [NOTIFICATION_TYPES.CLONE.value]: (
    <img src={ASSETS.notification_clone} alt="clone" style={{ width: '100%', height: '100%' }} />
  ),
  [NOTIFICATION_TYPES.SHARE.value]: (
    <img src={ASSETS.notification_share} alt="share" style={{ width: '100%', height: '100%' }} />
  ),
  [NOTIFICATION_TYPES.LIVE_CLONE.value]: (
    <img
      src={ASSETS.notification_live_clone}
      alt="liveclone"
      style={{ width: '100%', height: '100%' }}
    />
  ),
  [NOTIFICATION_TYPES.FAVORITE.value]: (
    <img src={ASSETS.notification_heart} alt="like" style={{ width: '100%', height: '100%' }} />
  ),
  [NOTIFICATION_TYPES.LOCK.value]: (
    <img src={ASSETS.notification_lock} alt="lock" style={{ width: '100%', height: '100%' }} />
  ),
  [NOTIFICATION_TYPES.FOLLOW.value]: (
    <img src={ASSETS.notification_follow} alt="follow" style={{ width: '100%', height: '100%' }} />
  ),
  [NOTIFICATION_TYPES.UNLOCK.value]: (
    <img src={ASSETS.notification_unlock} alt="unlock" style={{ width: '100%', height: '100%' }} />
  ),
};

// Image mapping for special types using NOTIFICATION_TYPES
const specialTypeImages = {
  [NOTIFICATION_TYPES.WARNING.value]: ASSETS.notification_warning,
  [NOTIFICATION_TYPES.STORAGE_WARNING.value]: ASSETS.notification_warning,
  [NOTIFICATION_TYPES.TAX.value]: ASSETS.notification_tax,
  [NOTIFICATION_TYPES.AUTO_DEPOSIT.value]: ASSETS.notification_autodeposit,
  [NOTIFICATION_TYPES.RED_STORAGE.value]: ASSETS.notification_red_storage,
  [NOTIFICATION_TYPES.YELLOW_STORAGE.value]: ASSETS.notification_yellow_storage,
  [NOTIFICATION_TYPES.TIP.value]: ASSETS.notification_bulb,
};

function NotificationItem({
  name,
  image,
  wheel,
  text,
  type,
  wheelName,
  time,
  isDropDown,
  isUnread,
  showActionButtons,
  wheelId
}) {
  const isSpecialType = Object.keys(specialTypeImages).includes(type.toString());
  const displayImage = isSpecialType ? specialTypeImages[type] : (image || ASSETS.person);
  const showWheelImage = !isSpecialType;
  const isWarning = type === NOTIFICATION_TYPES.WARNING.value;

  const renderTextWithBold = (text) => {
    const parts = text.split(/(<b>.*?<\/b>)/g).filter(Boolean);
    return parts.map((part, index) =>
      part.startsWith('<b>') && part.endsWith('</b>') ? (
        <span key={index} style={{ fontWeight: 'bold' }}>
          {part.slice(3, -4)}
        </span>
      ) : (
        <span key={index}>{part}</span>
      )
    );
  };

  const returnUrl = (notificationType) => {
    if ([NOTIFICATION_TYPES.SHARE.value, NOTIFICATION_TYPES.CLONE.value, NOTIFICATION_TYPES.LIVE_CLONE.value,
    NOTIFICATION_TYPES.FAVORITE.value, NOTIFICATION_TYPES.UNLOCK.value, NOTIFICATION_TYPES.LOCK.value,
    NOTIFICATION_TYPES.STORAGE_WARNING.value].includes(notificationType)) {
      return `/wheel/${wheelId}`;
    } else if (notificationType === NOTIFICATION_TYPES.TIP.value) {
      return `/referrals`;
    } else if ([NOTIFICATION_TYPES.WARNING.value, NOTIFICATION_TYPES.AUTO_DEPOSIT.value].includes(notificationType)) {
      return '/settings?option=subscriptions';
    } else if (notificationType === NOTIFICATION_TYPES.TAX.value) {
      return '/settings?option=security';
    } else {
      return '/settings';
    }
  }

  const nav = useNavigate()

  return (
    <NotificationContainer isWarning={isWarning} isUnread={isUnread} onClick={() => nav(returnUrl(type))}>
      <LeftSection>
        <ImageContainer>
          <ProfileImage src={displayImage} alt={name || type} />
          {type && iconMap[type] && <IconOverlay>{iconMap[type]}</IconOverlay>}
        </ImageContainer>
        <TextContainer>
          <TextView variant="subTitle" style={{ fontWeight: '500' }}>
            {name && (
              <>
                {name}
              </>
            )}
            <span style={{ color: '#696F8C' }}>{renderTextWithBold(text)}</span>
          </TextView>
          <TextView variant="subTitile">{wheelName}</TextView>
          {isDropDown && showActionButtons && (
            <ActionButtonsContainer>
              <StyledButton variant="accept">Accept</StyledButton>
              <StyledButton variant="deny">Deny</StyledButton>
            </ActionButtonsContainer>
          )}
          <TextView variant="text">{time}</TextView>
        </TextContainer>
      </LeftSection>

      {!isDropDown && wheel && [NOTIFICATION_TYPES.SHARE.value, NOTIFICATION_TYPES.CLONE.value,
      NOTIFICATION_TYPES.LIVE_CLONE.value, NOTIFICATION_TYPES.FAVORITE.value,
      NOTIFICATION_TYPES.UNLOCK.value, NOTIFICATION_TYPES.LOCK.value].includes(type) && (
          <RightSection>
            <WheelImage src={wheel} alt={name} />
          </RightSection>
        )}
      {isUnread && <GreenDot />}
    </NotificationContainer>
  );
}

export default NotificationItem;
